import Entity from "./Entity";
import {Tween, Group, Easing} from "@tweenjs/tween.js";

export default class DoorSurprise extends Entity {

    constructor(anchor, texture) {
        super(anchor, texture);

        this._tweens = new Group();

        this._monster = new PIXI.Sprite(P3.assets.texture("monster" + P3.math.randomInt(1, 4)));
        this._monster.anchor.set(0, 1);
        this._monster.position.set(360, 570);
        this._monster.scale.set(0.95);
        this.addChild(this._monster);

        this._doorRight = new PIXI.Sprite(P3.assets.texture("door_front_wall_1"));
        this._doorRight.anchor = anchor;
        this.addChild(this._doorRight);

        this._doorClosed = new PIXI.Sprite(P3.assets.texture("door_closed_1"));
        this._doorClosed.anchor = anchor;
        this.addChild(this._doorClosed);

        this._activated = false;

    }

    update(dt) {
        this._tweens.update();
    }

    activate() {
        if (this._activated)
            return;

        P3.audio.playSound("sfx_event_monster_appear_0" + P3.math.randomInt(0, 5));

        this._activated = true;
        this._doorClosed.visible = false;

        new Tween(this._monster, this._tweens)
            .to({x: this._monster.x - 180}, 600)
            .easing(Easing.Bounce.Out)
            .start();

        new Tween(this._monster.scale, this._tweens)
            .to({x: this._monster.scale.x + 0.01, y: this._monster.scale.y - 0.01}, 600 + Math.random() * 100)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start(Math.random() * 500);
    }

    deactivate() {
        if (this._deactivated)
            return;

        this._deactivated = true;

        new Tween(this._monster, this._tweens)
            .to({x: this._monster.x + 280}, 900)
            .easing(Easing.Quadratic.In)
            .onComplete(() => {
                this._doorClosed.visible = true;
            })
            .start();
    }

}